/* eslint-disable no-prototype-builtins */
export function isMobileApp() {
  return window.hasOwnProperty('cordova');
}
